import { IconProps } from './types';

export const IconReveal = ({ height = '24', width = '24', ...props }: IconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            {...props}
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 16C9.07938 16 6.29691 14.6168 5.08641 12C6.29691 9.38316 9.07938 8 12 8C14.9206 8 17.7031 9.38316 18.9136 12C17.7031 14.6168 14.9206 16 12 16ZM20.9316 11.6364C19.4426 7.82187 15.6458 6 12 6C8.35417 6 4.55737 7.82187 3.06845 11.6364C2.97718 11.8702 2.97718 12.1298 3.06845 12.3636C4.55737 16.1781 8.35417 18 12 18C15.6458 18 19.4426 16.1781 20.9316 12.3636C21.0228 12.1298 21.0228 11.8702 20.9316 11.6364ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                fill="currentColor"
            />
        </svg>
    );
};
